import { NgModule, Optional, SkipSelf } from '@angular/core';
import { InitializerService } from '@app/core/services/initializer.service';
import { RoutingModule } from '@app/routing/routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { InitialRoutingComponent } from './components/initial-routing/initial-routing.component';
import { RedirRoutingComponent } from './components/redir-routing/redir-routing.component';
import { throwIfAlreadyLoaded } from './module-import-guard';

@NgModule({
  imports: [SharedModule, RoutingModule],
  declarations: [InitialRoutingComponent, RedirRoutingComponent],
  providers: [InitializerService],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    // Ensure that the core module is only loaded once (https://angular.io/guide/styleguide#style-04-12)
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
